export const userCloseHandler = (msgData, store, roomClient) => {
  store.commit("mediasoup/remove_peer", msgData.closedPeerId);
  store.commit("mediasoup/remove_from_allPeer", msgData.closedPeerId);
  roomClient.setConferenceState(msgData.closedPeerId);
};

export const newUserHandler = (msgData, store, roomClient) => {
  if (msgData.peer.id !== roomClient._peerId) {
    store.commit("mediasoup/add_peer", msgData.peer);
    store.commit("mediasoup/add_to_all_peer", msgData.peer);
  }
};

export const remoteCloseHandler = (msgData, roomClient) => {
  if (msgData.peerId === roomClient._peerId) {
    roomClient.close();
    alert("You got removed!");
    window.location.href = "https://goqonda.io";
  }
};
